<svg fill="none" height="21" viewBox="0 0 22 21" width="22" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M12.607 16.3945H9.39276V19.0604L7.93066 20.6133H14.0691L12.607 19.0604V16.3945Z"
    fill="white"
    fill-opacity="0.75"
  />
  <path
    d="M7.42211 8.72046H4.37256C4.53609 9.41073 5.15805 9.92582 5.89734 9.92582C6.63662 9.92582 7.25858 9.41073 7.42211 8.72046Z"
    fill="white"
    fill-opacity="0.75"
  />
  <path
    d="M17.067 7.59549C17.3999 7.59549 17.6697 7.32567 17.6697 6.99282C17.6697 6.65997 17.3999 6.39014 17.067 6.39014C16.7342 
    6.39014 16.4644 6.65997 16.4644 6.99282C16.4644 7.32567 16.7342 7.59549 17.067 7.59549Z"
    fill="white"
    fill-opacity="0.75"
  />
  <path
    d="M2.71436 0.925781C1.60979 0.925781 0.714355 1.82121 0.714355 2.92578V13.1892C0.714355 14.2937 1.60979 15.1892 2.71436 
    15.1892H19.2858C20.3903 15.1892 21.2858 14.2937 21.2858 13.1892V2.92578C21.2858 1.82121 20.3904 0.925781 19.2858 0.925781H2.71436ZM17.6697 
    8.69712V10.9102C17.6697 12.1617 16.6512 13.1802 15.3996 13.1802C14.1481 13.1802 13.1295 12.1617 13.1295 10.9102V9.7048C13.1295 
    9.11779 12.6518 8.64007 12.0648 8.64007C11.4778 8.64007 11.0001 9.11779 11.0001 9.7048V10.5285C11.0001 11.9906 9.81038 13.1802 
    8.34828 13.1802H7.9465C6.67244 13.1802 5.60529 12.277 5.35177 11.0773C4.08333 10.823 3.12507 9.70078 3.12507 
    8.35882V3.81864H5.29471V5.024H4.33043V7.51507H7.46435V5.024H6.50007V3.81864H8.66971V8.35882C8.66971 9.64694 7.78699 
    10.7326 6.59449 11.0423C6.80221 11.5872 7.32976 11.9749 7.9465 11.9749H8.34828C9.14583 11.9749 9.79471 11.326 9.79471 
    10.5285V9.7048C9.79471 8.45324 10.8132 7.43471 12.0648 7.43471C13.3164 7.43471 14.3349 8.45324 14.3349 9.7048V10.9102C14.3349 
    11.4972 14.8126 11.9749 15.3996 11.9749C15.9866 11.9749 16.4644 11.4972 16.4644 10.9102V8.69712C15.7628 8.44882 15.259 7.77824 
    15.259 6.99275C15.259 5.99591 16.0702 5.18471 17.067 5.18471C18.0639 5.18471 18.8751 5.99591 18.8751 6.99275C18.8751 7.77824 
    18.3712 8.44882 17.6697 8.69712Z"
    fill="white"
    fill-opacity="0.75"
  />
</svg>
